import { useState } from 'react';
import { api } from '../lib/api';
import { useFetch } from '../lib/useFetch';
import { buildCategoriaOptions } from '../lib/ui';
import { useToast } from '../components/Toast';
import type { PageProps } from '../App';
import type { FormaPagamento } from '../types';

const num = (s: string) => { const n = parseFloat((s || '').replace(/\./g, '').replace(',', '.')); return isNaN(n) ? 0 : n; };

export function NovoLancamento({ navigate }: PageProps) {
  const toast = useToast();
  const plano = useFetch(() => api.listPlano(), []);
  const catOptions = plano.data ? buildCategoriaOptions(plano.data.items) : [];

  const [tipo, setTipo] = useState<'despesa' | 'receita'>('despesa');
  const [fornecedor, setFornecedor] = useState('');
  const [descricao, setDescricao] = useState('');
  const [valor, setValor] = useState('');
  const [venc, setVenc] = useState('');
  const [parcelas, setParcelas] = useState(1);
  const [cat, setCat] = useState<number | ''>('');
  const [forma, setForma] = useState<FormaPagamento>('boleto');
  const [erro, setErro] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const salvar = async () => {
    setErro(null);
    if (!fornecedor.trim()) { setErro('Informe o fornecedor.'); return; }
    setBusy(true);
    try {
      const r = await api.criarConta({
        tipo, fornecedor: fornecedor.trim(), descricao: descricao || undefined,
        valor: valor ? num(valor) : undefined, vencimento: venc || undefined,
        parcelas, plano_conta_id: cat ? Number(cat) : undefined, forma_pagamento: forma,
      });
      toast(`Lançamento criado${r.parcelas > 1 ? ` em ${r.parcelas} parcelas` : ''}.`);
      navigate('contas');
    } catch (e) {
      const body = (e as { body?: { error?: string } }).body;
      setErro(body?.error === 'retencao_nao_suporta_parcelamento' ? 'Retenções não combinam com parcelamento.' : 'Falha ao salvar lançamento.');
      setBusy(false);
    }
  };

  return (
    <div className="page form">
      <h1 style={{ marginBottom: 20 }}>Lançamento manual</h1>
      <div className="card pad-lg">
        <div className="row" style={{ gap: 8, marginBottom: 18 }}>
          <span className={`chip ${tipo === 'despesa' ? 'active' : ''}`} onClick={() => setTipo('despesa')}>Despesa</span>
          <span className={`chip ${tipo === 'receita' ? 'active' : ''}`} onClick={() => setTipo('receita')}>Receita</span>
        </div>

        <div className="field">
          <label>Fornecedor</label>
          <input className="input" placeholder="Digite para buscar ou criar…" value={fornecedor} onChange={(e) => setFornecedor(e.target.value)} />
        </div>
        <div className="field">
          <label>Descrição</label>
          <input className="input" value={descricao} onChange={(e) => setDescricao(e.target.value)} />
        </div>

        <div className="grid-3" style={{ marginBottom: 14 }}>
          <div><label className="flabel">Valor (R$)</label><input className="input mono" placeholder="0,00" value={valor} onChange={(e) => setValor(e.target.value)} /></div>
          <div><label className="flabel">Vencimento</label><input type="date" className="input" value={venc} onChange={(e) => setVenc(e.target.value)} /></div>
          <div><label className="flabel">Parcelas</label>
            <select className="select" value={parcelas} onChange={(e) => setParcelas(Number(e.target.value))}>
              {Array.from({ length: 12 }, (_, i) => i + 1).map((p) => <option key={p} value={p}>{p}x</option>)}
            </select>
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 12, marginBottom: 20 }}>
          <div><label className="flabel">Categoria</label>
            <select className="select" value={cat} onChange={(e) => setCat(e.target.value ? Number(e.target.value) : '')}>
              <option value="">Deixar para a IA classificar</option>
              {catOptions.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
            </select>
          </div>
          <div><label className="flabel">Forma</label>
            <select className="select" value={forma} onChange={(e) => setForma(e.target.value as FormaPagamento)}>
              <option value="boleto">Boleto</option><option value="pix">PIX</option>
              <option value="transferencia">Transferência</option><option value="cartao">Cartão</option><option value="outro">Outro</option>
            </select>
          </div>
        </div>

        {erro && <div className="login-err" style={{ marginBottom: 14 }}>{erro}</div>}
        <button className="btn dark" onClick={salvar} disabled={busy}>Salvar lançamento</button>
      </div>
    </div>
  );
}
